import type { ChecklistAdviceStatus } from '@arhs-fleetback/types/entities/checklists';

import * as types from 'modules/checklists/actionTypes';
import type { PatchAdviceAction, PatchAdviceFailureAction, PatchAdviceSuccessAction } from 'modules/checklists/types';
import { createReducer } from 'utils/ReduxUtils';

export type PatchingAdviceSlice = {
  error: unknown;
  isLoading: boolean;
  step: 'request' | 'error' | 'success';
  status: ChecklistAdviceStatus | null;
};

export type ChecklistUiDetailsPatchingAdviceReducer = Record<string, PatchingAdviceSlice>;

const initialState: ChecklistUiDetailsPatchingAdviceReducer = {};

const updateBeforePatching = (
  state: ChecklistUiDetailsPatchingAdviceReducer,
  { payload }: PatchAdviceAction
): ChecklistUiDetailsPatchingAdviceReducer => {
  const { adviceId, checklistId } = payload;
  const field = `${checklistId}-${adviceId}`;

  return {
    ...state,
    [field]: {
      error: null,
      isLoading: true,
      step: 'request',
      status: payload.request.data.status,
    },
  };
};

const updateAfterPatching = (
  state: ChecklistUiDetailsPatchingAdviceReducer,
  { type, payload }: PatchAdviceSuccessAction | PatchAdviceFailureAction
): ChecklistUiDetailsPatchingAdviceReducer => {
  const { adviceId, checklistId } = payload;
  const field = `${checklistId}-${adviceId}`;
  const step = type === types.PATCH_ADVICE_FAILURE ? 'error' : 'success';

  return {
    ...state,
    [field]: {
      ...(state[field] ?? { status: null }),
      error: payload.message ?? null,
      isLoading: false,
      step,
    },
  };
};

export default createReducer(initialState, {
  [types.PATCH_ADVICE]: updateBeforePatching,
  [types.PATCH_ADVICE_SUCCESS]: updateAfterPatching,
  [types.PATCH_ADVICE_FAILURE]: updateAfterPatching,
});
